import { useEffect, useMemo } from 'react';

interface ConfettiProps {
  active: boolean;
  onDone?: () => void;
}

const COLORS = [
  'var(--confetti-1)', 'var(--confetti-2)', 'var(--confetti-3)',
  'var(--confetti-4)', 'var(--confetti-5)', 'var(--confetti-6)',
];

const PIECE_COUNT = 30;
const DURATION_MS = 1500;

// Basit deterministik PRNG (test stabilitesi için)
function seededRandom(seed: number): () => number {
  let s = seed;
  return () => {
    s = (s * 9301 + 49297) % 233280;
    return s / 233280;
  };
}

export function Confetti({ active, onDone }: ConfettiProps) {
  const pieces = useMemo(() => {
    if (!active) return [];
    const rand = seededRandom(42);
    return Array.from({ length: PIECE_COUNT }, (_, i) => ({
      id: i,
      leftPct: rand() * 100,
      delayMs: rand() * 400,
      rotation: rand() * 720 - 360,
      color: COLORS[Math.floor(rand() * COLORS.length)],
    }));
  }, [active]);

  useEffect(() => {
    if (!active) return;
    const t = setTimeout(() => onDone?.(), DURATION_MS);
    return () => clearTimeout(t);
  }, [active, onDone]);

  if (!active) return null;

  return (
    <div className="confetti-container" aria-hidden="true">
      {pieces.map((p) => (
        <span
          key={p.id}
          className="confetti-piece"
          style={{
            left: `${p.leftPct}%`,
            background: p.color,
            animationDelay: `${p.delayMs}ms`,
            ['--rot' as string]: `${p.rotation}deg`,
          }}
        />
      ))}
    </div>
  );
}